import * as React from "react";
import FormikAutocompleteField from "../../formik/FormikAutocomplete";
import PropTypes from "prop-types";
import { HttpClientConfig } from "../../../utils/HttpClient";

export const TaskServiceAutocomplete = (props) => {
  const lookupUrl = `${HttpClientConfig.baseURL}/TaskService/Lookup`;
  const lookupByIdUrl = `${HttpClientConfig.baseURL}/TaskService/LookupById`;

  const handleAddClick = (e) => {
    console.log(e);
  }

  return (
    <FormikAutocompleteField {...props} lookupUrl={lookupUrl} lookupByIdUrl={lookupByIdUrl} onAddButtonClick={handleAddClick} />
  );
};

TaskServiceAutocomplete.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.any
}

export default TaskServiceAutocomplete;
